import { render, staticRenderFns } from "./ServiceLogView.vue?vue&type=template&id=3b04ced2&"
import script from "./ServiceLogView.vue?vue&type=script&lang=ts&"
export * from "./ServiceLogView.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceLogView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports